import './default_module'
import { tooltip, loadAsync, navTabs } from 'javascripts/general_scripts'
import { captureImpression } from 'javascripts/impressions/capture_impression.js';

/* stylesheet */
import 'stylesheets/products/show.less'

window.gitbTooltip = tooltip;
navTabs();

function prepareAndCaptureImpression($element) {
  if (window.dataLayer[0].itcsUser) { return }

  let { shareUrl } = $element.find('a.share-this').data();
  if (!shareUrl) { console.error('Data attribute shareUrl is missing from the product review container!') }
  captureImpression(shareUrl);
}

$('body').on('click', '.full-review.expander', function () {
  if ($(this).find('p.closed').length) { return } // means that review was just closed

  prepareAndCaptureImpression($(this).closest('.embedded-product-review1'));
});

if(window.location.hash == '#reviews-container') {
  $('.reviews-link').addClass('active');
  $('.overview-link').removeClass('active');
} else if (window.location.hash.startsWith('#review_')) { // means that this is a link to a specific review
  let reviewId = window.location.hash.replace('#review_', '');
  let reviewContainer = $(`div[data-product_review_id="${reviewId}"]`);

  prepareAndCaptureImpression(reviewContainer);
}

// remove ?page=1 from any URLs - generated with will_paginate
if ($('a[href$="/page-1"]').length) {
  $('a[href$="/page-1"]').each(function () {
    var href = $(this).attr('href');
    $(this).attr('href', href.substring(0, href.indexOf('/page-')));
  });
}
